import React from 'react'
// libs
import styled from 'styled-components'
// constants
import { Modals } from 'constants/index'
// context
import { DataHubAPIContext } from 'containers/DataHub/layers/API'
// components
import { Modal } from 'components/UI'
import ReportForm from './Form'
// hooks
import { useModalData } from 'hooks/index'
// themes
import { colors } from 'themes'
import { CloseIcon } from 'components/UI/Icons'

const PAPER_PROPS = {
  style: {
    padding: '16px'
  }
}

const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
`

const UpdateReportModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, report }
  } = useModalData({ modalType: Modals.REPORT_UPDATE_MODAL })

  const { updateReport } = React.useContext(DataHubAPIContext)

  if (!report) {
    return null
  }

  const initialValues = { name: report.customName || report.name }

  const onFormSubmit = async (data) => {
    await updateReport(report.id, { customName: data.name })

    hideModal()
  }

  return (
    <Modal
      width={'xs'}
      isOpen={isOpen}
      disableRestoreFocus
      disableBackdropClick
      disableEscapeKeyDown
      hideModal={hideModal}
      PaperProps={PAPER_PROPS}>
      <Header>
        <span>Update Report</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <ReportForm initialValues={initialValues} onSubmit={onFormSubmit} hideModal={hideModal} />
    </Modal>
  )
}

export default UpdateReportModal
